"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
class UpdateApiWrapper {
  // 获取客户端更新信息
  getClientVersion() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.local/update/version`);
        return response.data;
      } catch (error) {
        throw error;
      }
    });
  }
  // 创建客户端更新任务
  createUpdateTask(updateInfo) {
    return __async(this, null, function* () {
      try {
        const response = yield API.post(`api://base.local/update/tasks`, updateInfo);
        return response.data;
      } catch (error) {
        throw error;
      }
    });
  }
}
export const updateAPI = new UpdateApiWrapper();
